import { useEffect, useRef } from 'react'
import { App as FlareApp } from '@/chat/host'
import type { BrandingState } from '@/hooks/chat/brandingState'
import { usePageConfig } from '@/chat/host/config/usePageConfig'
import './styles.css'

const FUNCTION_TYPE = import.meta.env.VITE_CHAT_FUNCTION_TYPE || 'auto'
const DEFAULT_SESSION_TITLE = import.meta.env.VITE_CHAT_DEFAULT_SESSION_TITLE || '新会话'
export type CoreEntryPageProps = {
  branding: BrandingState
  onReady: () => void
}

function CoreEntryPage({ branding, onReady }: CoreEntryPageProps) {
  const reportedReadyRef = useRef(false)
  const appConfig = usePageConfig({ branding, projectId: '', defaultProjectName: branding.projectSlot.name,
    functionType: FUNCTION_TYPE, defaultSessionTitle: DEFAULT_SESSION_TITLE })

  // The outer startup screen tracks first paint, not Controller/backend readiness.

  useEffect(() => {
    if (reportedReadyRef.current) {
      return
    }
    let secondFrame = 0
    const firstFrame = window.requestAnimationFrame(() => {
      secondFrame = window.requestAnimationFrame(() => {
        reportedReadyRef.current = true
        onReady()
      })
    })
    return () => {
      window.cancelAnimationFrame(firstFrame)
      window.cancelAnimationFrame(secondFrame)
    }
  }, [onReady])

  return (
    <div className="core-entry-page">
      <main className="core-entry-main">
        <FlareApp {...appConfig} />
      </main>
    </div>
  )
}

export default CoreEntryPage
